import React from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../molecules/Header';
import Footer from '../../molecules/Footer';
import { useSelector } from 'react-redux';
import { CustomerAppState } from 'src/redux/modules/store';
import { getMessageFromMasterInfo, MESSAGE_MASTER_KEYS } from '@common/redux/reducers/MasterInfoReducer';
import OptinMailDoneContent from '../../organisms/OptinMailDoneContent';
import { MAIL_PERMISSION_TYPE, SCREEN } from '@common/Common';
import { useEffect } from 'react';

/**
 * メール受信の承諾 完了画面
 */
const OptinMailtDone: React.FC = () => {
  const history = useHistory();
  const masterInfo = useSelector((state: CustomerAppState) => state.masterInfo);
  const optinMailState = useSelector((state: CustomerAppState) => state.optinMail);
  // メール受信の許諾完了画面タイトル
  let optinMailitle = '';
  // メール受信の許諾完了画面詳細
  let optinMailDoneDetail = '';
  // メールパーミッション区分：11(承諾（遠隔）の場合)
  if (optinMailState.mailPermissionType === MAIL_PERMISSION_TYPE.CONSENT_REMOTE) {
    optinMailitle = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0001);
    optinMailDoneDetail = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0003);
    // メールパーミッション区分：10(拒否（遠隔）の場合)
  } else if (optinMailState.mailPermissionType === MAIL_PERMISSION_TYPE.DENY_REMOTE) {
    optinMailitle = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0002);
    optinMailDoneDetail = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0011);
  } else {
    history.push(SCREEN.MAIL_OPTIN_ERROR.URL);
  }
  // ページ位置を上にする
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <OptinMailDoneContent title={optinMailitle} detail={optinMailDoneDetail} />
      <Footer />
    </div>
  );
};

export default OptinMailtDone;
